import Vue from 'vue'
import Vuex from 'vuex'

import Im from './modules/im'
import Layout from './modules/layout'
import Room from './modules/room'
import ScreenShare from './modules/screenshare'
import Settings from './modules/settings'
import User from './modules/user'
import TeamCenter from './modules/team-center';
import Record from './modules/record'
import Audio from './modules/audio'
import Friends from './modules/friends'
import Group from './modules/group'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    'user': User,
    'settings': Settings,
    'room': Room,
    'screenshare': ScreenShare,
    'im': Im,
    'layout': Layout,
    'teamCenter': TeamCenter,
    'record': Record,
    'audio': Audio,
    'friends': Friends,
    'group': Group,
  }
})
